<template>
  <Tooltip
    :placement="placement"
    :triggers="['hover', 'focus', 'click']"
  >
    <div class="is-flex is-flex--align-center mt-tooltip-icon--price-wrapper">
      <span class="mt-error mt-error--bundle-price"> {{ $t('pages.bundle.draft.bundle_price.invalid_amount') }} </span>
      <TooltipIcon class="mt-tooltip-icon--price" />
    </div>
    <template #popper>
      <span>{{ $t('pages.bundle.draft.bundle_price.validation_error_tooltip_title') }}</span>
      <div
        v-if="!isEmpty(errors)"
        data-qa-id="error-wrapper"
      >
        <div
          v-for="(error, i) in errors"
          :key="i"
        >
          {{ ++i }}. {{ error }}
        </div>
      </div>
    </template>
  </Tooltip>
</template>

<script src="./script/index"></script>

<style lang="scss">
@import 'mpl-css/lib/assets/global/functions/index';
.mt-tooltip-icon--price {
  color: #fff;
}

.mt-tooltip-icon--price-wrapper {
  gap: rem(4);
}
</style>
